// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"e6dbcb2c","152":"aeaa670d","322":"697e73cb"}[chunkId] + ".chunk.js";
};